import { DateParts } from '@repo/redux/actions/csvImport';

export const CSV_UPLOAD_TEMPLATE_URL = 'https://go.clay.earth/csv-template';

export const NAME = 'name';
export const FIRST_NAME = 'first name';
export const LAST_NAME = 'last name';
export const EMAIL = 'email';
export const PHONE = 'phone';
export const LINKEDIN_URL = 'linkedin url';
export const FACEBOOK_URL = 'facebook url';
export const TWITTER_URL = 'twitter url';
export const NOTE = 'note';
export const GROUPS = 'groups';
export const BIRTHDAY = 'birthday';
export const TITLE = 'title';
export const COMPANY = 'company';
export const WEBSITE = 'website';
export const HEADLINE = 'headline';
export const CADENCE = 'cadence';
export const ADDRESS_STREET = 'address - street';
export const ADDRESS_CITY = 'address - city';
export const ADDRESS_STATE = 'address - state';
export const ADDRESS_POSTAL_CODE = 'address - postal code';
export const ADDRESS_COUNTRY = 'address - country';

const PRETTY_NAME = 'Name';
const PRETTY_FIRST_NAME = 'First Name';
const PRETTY_LAST_NAME = 'Last Name';
const PRETTY_EMAIL = 'Email';
const PRETTY_PHONE = 'Phone';
const PRETTY_LINKEDIN_URL = 'LinkedIn URL';
const PRETTY_FACEBOOK_URL = 'Facebook URL';
const PRETTY_TWITTER_URL = 'Twitter URL';

export const PIIFields = `"${PRETTY_NAME}", "${PRETTY_EMAIL}", "${PRETTY_PHONE}", "${PRETTY_LINKEDIN_URL}", "${PRETTY_FACEBOOK_URL}", "${PRETTY_TWITTER_URL}", or both "${PRETTY_FIRST_NAME}" and "${PRETTY_LAST_NAME}"`;

export interface CSVRecord {
  // Lookup fields. Need to have at least one of these (or both First Name and Last Name together)
  'name'?: string;
  'first name'?: string;
  'last name'?: string;
  'email'?: string;
  'phone'?: string;
  'linkedin url'?: string;
  'facebook url'?: string;
  'twitter url'?: string;

  'note'?: string;
  'groups'?: string;
  'birthday'?: string;
  'title'?: string;
  'company': string;
  'website'?: string;
  'headline'?: string;
  'cadence'?: string;
  // Address fields
  'address - street'?: string;
  'address - city'?: string;
  'address - state'?: string;
  'address - postal code'?: string;
  'address - country'?: string;
}

export type CSVRecordWithErrors = CSVRecord & { _error?: string; _warnings?: string };

export type CSVField = keyof CSVRecord;

export const supportedFields = [
  NAME,
  FIRST_NAME,
  LAST_NAME,
  EMAIL,
  PHONE,
  LINKEDIN_URL,
  FACEBOOK_URL,
  TWITTER_URL,
  NOTE,
  GROUPS,
  BIRTHDAY,
  TITLE,
  COMPANY,
  WEBSITE,
  HEADLINE,
  CADENCE,
  ADDRESS_STREET,
  ADDRESS_CITY,
  ADDRESS_STATE,
  ADDRESS_POSTAL_CODE,
  ADDRESS_COUNTRY,
];

export const CLAY_ERROR = '_error';
export const CLAY_WARNINGS = '_warnings';

export const clayAddedFields = [CLAY_ERROR, CLAY_WARNINGS];

export interface ValidationResult {
  valid: boolean;
  error?: string;
  sanitizedValue?: string | string[] | DateParts;
}
